function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Checkbox, Label, Spinner } from "flowbite-react";
import { useSearchContext } from "../utils/Context";
import { LinkClasses, ThreadTypes } from "../utils/Constants";
import { gaEvent } from "../utils/Utils";
var Facets = function Facets() {
  var _useSearchContext = useSearchContext(),
    threadFilters = _useSearchContext.threadFilters,
    setThreadFilters = _useSearchContext.setThreadFilters,
    searching = _useSearchContext.searching,
    allData = _useSearchContext.allData;
  if (searching) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-8 md:mt-0 lg:mt-8 md:w-1/2 lg:w-full md:pl-4 lg:pl-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hidden md:flex flex-col text-center "
    }, /*#__PURE__*/React.createElement(Spinner, {
      "aria-label": "Searching...",
      size: "md"
    })));
  }
  if (!threadFilters || Object.keys(threadFilters).length <= 1 || allData === undefined) {
    return null;
  }
  var handleChange = function handleChange(e) {
    setThreadFilters(_objectSpread(_objectSpread({}, threadFilters), {}, _defineProperty({}, e.target.name, e.target.checked)));
    gaEvent("filter", {
      category: "Filter",
      label: e.target.checked ? 'Show' : 'Hide',
      value: e.target.name,
      nonInteraction: true
    });
  };
  var handleOnly = function handleOnly(key) {
    setThreadFilters(Object.fromEntries(Object.keys(threadFilters).map(function (subkey) {
      return [subkey, subkey === key];
    })));
    gaEvent("filter", {
      category: "Filter",
      label: "Only",
      value: key,
      nonInteraction: true
    });
  };
  var handleAll = function handleAll() {
    setThreadFilters(Object.fromEntries(Object.keys(threadFilters).map(function (key) {
      return [key, true];
    })));
    gaEvent("filter", {
      category: "Filter",
      label: "All",
      value: "All",
      nonInteraction: true
    });
  };
  var allChecked = Object.values(threadFilters).every(function (v) {
    return v;
  });
  var selectAll;
  if (!allChecked) {
    selectAll = /*#__PURE__*/React.createElement("button", {
      className: "text-sm ".concat(LinkClasses),
      onClick: handleAll
    }, "Select All");
  }
  var threadFiltersList = Object.entries(threadFilters);
  var threadsFilter = threadFiltersList.map(function (_ref, i) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    var checkboxId = key.replace(/\s/g, '-').toLowerCase();
    var listItemClasses;
    switch (i) {
      case 0:
        listItemClasses = "rounded-t-lg border-b border-gray-200 dark:border-gray-600";
        break;
      case threadFiltersList.length - 1:
        listItemClasses = "rounded-b-lg";
        break;
      default:
        listItemClasses = "border-b border-gray-200 dark:border-gray-600";
    }
    return /*#__PURE__*/React.createElement("li", {
      className: "flex items-center flex-wrap gap-4 facet py-2 px-4 w-full ".concat(listItemClasses),
      key: i
    }, /*#__PURE__*/React.createElement(Checkbox, {
      id: checkboxId,
      name: key,
      checked: value,
      onChange: handleChange
    }), /*#__PURE__*/React.createElement(Label, {
      htmlFor: checkboxId,
      className: "cursor-pointer"
    }, ThreadTypes.hasOwnProperty(key) ? ThreadTypes[key].name : "None"), /*#__PURE__*/React.createElement("button", {
      className: "text-xs ".concat(LinkClasses),
      "aria-label": "show only ".concat(key, " thread results"),
      onClick: function onClick() {
        return handleOnly(key);
      }
    }, "only"));
  });
  return /*#__PURE__*/React.createElement("div", {
    role: "region",
    "aria-label": "Search Result Filters",
    className: "mt-8 md:mt-0 lg:mt-8 md:w-1/2 lg:w-full md:pl-4 lg:pl-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-1 flex justify-between items-center"
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "threads-filter"
  }, "Threads Filter"), selectAll), /*#__PURE__*/React.createElement("ul", {
    id: "threads-filter",
    className: "text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
  }, threadsFilter));
};
export default Facets;